import { Package, Truck } from "lucide-react";
import { Choice, Field, inputCls } from "./Field";

export const StepHandoff = ({ f, set, errors }) => (
  <div className="space-y-8">
    <div className="grid gap-4 sm:grid-cols-2">
      <Choice testId="handoff-collection-option" active={f.handoff === "collection"} onClick={() => set("handoff", "collection")} icon={Truck} title="Pick it up from me" text="We'll contact you to arrange a pick-up time" />
      <Choice testId="handoff-post-option" active={f.handoff === "post"} onClick={() => set("handoff", "post")} icon={Package} title="I'll post it" text="We'll contact you with where to send it" />
    </div>
    {errors.handoff && <p className="text-xs text-red-400">{errors.handoff}</p>}
    {f.handoff === "post" && (
      <div data-testid="post-details" className="flex items-start gap-3 border-l-2 border-ember bg-white/[0.02] p-4 text-sm">
        <Package className="mt-0.5 h-4 w-4 shrink-0 text-ember" />
        <p className="text-slate-300">Please don't send anything yet. Once we've reviewed your request we'll be in touch with the postal address. Pack it securely and keep your proof of postage.</p>
      </div>
    )}
    {f.handoff === "collection" && (
      <Field label="Pick-up address" error={errors.address}>
        <textarea data-testid="collection-address-input" rows={3} className={`${inputCls} resize-none`} value={f.address} onChange={(e) => set("address", e.target.value)} placeholder="House number, street, town, postcode" />
      </Field>
    )}
  </div>
);
